import { createPortal } from "react-dom";
import { Button, Modal } from "shared";
import { useRestoreAsset } from "hooks/investments";
import { InvestmentItem } from "../../types";

interface RestoreAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: InvestmentItem | null;
  onSuccess?: (uuid: string) => void;
}

const RestoreAssetModal = ({
  isOpen,
  onClose,
  item,
  onSuccess,
}: RestoreAssetModalProps) => {
  const { mutate: restoreAsset, isPending } = useRestoreAsset();

  const handleRestore = () => {
    if (!item) return;
    restoreAsset(
      { uuid: item.uuid },
      {
        onSuccess: () => {
          onClose();
          onSuccess?.(item.uuid);
        },
      },
    );
  };

  return createPortal(
    <Modal isOpened={isOpen} onClose={onClose}>
      <>
        <div className="modal-heading">Przywracanie aktywa</div>
        <div className="modal-description">
          Czy na pewno chcesz przywrócić aktywo?
        </div>
        <div className="modal-buttons">
          <Button
            className="button--stroke button--rounded"
            onClick={onClose}
            label="Anuluj"
          />
          <Button
            className="button--black button--rounded"
            onClick={handleRestore}
            label={isPending ? "Przywracanie..." : "Potwierdź"}
          />
        </div>
      </>
    </Modal>,
    document.body,
  );
};

export default RestoreAssetModal;
